import api from './api';

export const documentTypeService = {
  async list(params = {}) {
    const response = await api.get('/document-types/', { params });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/document-types/', payload);
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/document-types/${id}`);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/document-types/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    return this.update(id, { is_active: false });
  },

  async permanentDelete(id) {
    return api.delete(`/document-types/${id}/permanent`);
  },
};
